document.addEventListener("DOMContentLoaded", function () {
  const picker = document.querySelector(".athleto-flavor-picker");
  if (!picker) return;

  const cards = picker.querySelectorAll(".athleto-flavor-card");
  const selectedLabel = document.getElementById("AthletoSelectedFlavor");

  const variantSelects = document.querySelector("variant-selects");
  if (!variantSelects) {
    console.warn("Variant-selects element not found.");
    return;
  }

  // Find the first option select (flavor)
  const select = variantSelects.querySelectorAll("select")[1];
  if (!flavorSelect) {
    console.warn("Flavor select not found.");
    return;
  }

  const productForm = flavorSelect.closest("form");
  const mainImage = document.querySelector(".product__media img"); // adjust selector if needed

  function setActive(value) {
    cards.forEach((card) => {
      card.classList.toggle("is-active", card.dataset.optionValue === value);
    });
    if (selectedLabel) {
      selectedLabel.textContent = value;
    }
  }

  // --- Manual image update (fallback) ---
  function updateMainImage(variantId) {
    if (!mainImage) return;
    // Find the variant image from the product data
    const productJSON = document.querySelector('[data-product-json]');
    if (!productJSON) return;
    try {
      const productData = JSON.parse(productJSON.textContent);
      const variant = productData.variants.find(v => v.id === variantId);
      if (variant && variant.featured_image) {
        mainImage.src = variant.featured_image.src;
        mainImage.srcset = variant.featured_image.srcset; // optional
      }
    } catch (e) {}
  }

  // --- Core selection function ---
  function selectVariant(value) {
    if (!value) return;

    // 1. Set the select value and mark option selected
    flavorSelect.value = value;
    const option = flavorSelect.querySelector(`option[value="${value}"]`);
    if (option) {
      option.selected = true;
    }

    // 2. Fire multiple events to cover all listeners
    const events = ['change', 'input', 'variant-change'];
    events.forEach(eventType => {
      flavorSelect.dispatchEvent(new Event(eventType, { bubbles: true }));
      variantSelects.dispatchEvent(new Event(eventType, { bubbles: true }));
      if (productForm) {
        productForm.dispatchEvent(new Event(eventType, { bubbles: true }));
      }
    });

    // 3. Update active state
    setActive(value);

    // 4. Fallback: if the image doesn't update after a short delay, force it
    setTimeout(() => {
      // If the select value was reset, reapply
      if (flavorSelect.value !== value) {
        flavorSelect.value = value;
        const opt = flavorSelect.querySelector(`option[value="${value}"]`);
        if (opt) opt.selected = true;
        flavorSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // If the main image still hasn't changed, try manual update
      const variantId = getVariantIdFromOption(value);
      if (variantId) {
        updateMainImage(variantId);
      }
    }, 300);
  }

  // Helper to get variant ID from option value
  function getVariantIdFromOption(value) {
    const productJSON = document.querySelector('[data-product-json]');
    if (!productJSON) return null;
    try {
      const productData = JSON.parse(productJSON.textContent);
      // Find the variant that matches the first option value
      const found = productData.variants.find(v => v.option1 === value);
      return found ? found.id : null;
    } catch (e) {
      return null;
    }
  }

  // Click handler for custom flavor cards
  cards.forEach((card) => {
    card.addEventListener("click", function () {
      const value = this.dataset.optionValue;
      selectVariant(value);
    });
  });

  // Keep active card synced if Dawn changes the variant via other controls
  flavorSelect.addEventListener("change", function () {
    setActive(this.value);
  });

  // Initial state
  setActive(flavorSelect.value);

  // ---------- Nutrition Popup (unchanged) ----------
  const modal = document.querySelector(".athleto-nutrition-modal");
  const openBtn = document.querySelector("[data-athleto-nutrition]");
  const closeBtn = document.querySelector(".athleto-close-nutrition");
  const overlay = document.querySelector(".athleto-nutrition-overlay");

  if (modal && openBtn) {
    openBtn.addEventListener("click", () => {
      modal.hidden = false;
    });

    function closeModal() {
      modal.hidden = true;
    }

    if (closeBtn) closeBtn.addEventListener("click", closeModal);
    if (overlay) overlay.addEventListener("click", closeModal);
  }
});